import { render } from "./UUtemplate.vue?vue&type=template&id=169bc53a&scoped=true"
import script from "./UUtemplate.vue?vue&type=script&lang=js"
export * from "./UUtemplate.vue?vue&type=script&lang=js"

import "./UUtemplate.vue?vue&type=style&index=0&id=169bc53a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-169bc53a"

export default script